export const environment = {
  name: 'Development',
  apiUrl: '/api/',
  issueReportApiUrl: 'http://localhost:3001/api/',
  apiUrlLocal: '',
  production: false,
  livekitUrl: 'wss://livekit.portal.praband.com', // match your backend
};
